export default __webpack_public_path__ + "static/media/infoIllustration1.01225e58.gif";